import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { IngresoService } from '../../servicios/ingreso.service';

@Component({
  selector: 'app-encuesta-grupo',
  templateUrl: './encuesta-grupo.component.html',
  styleUrls: ['./encuesta-grupo.component.css']
})
export class EncuestaGrupoComponent implements OnInit {

  public mr: NgbModalRef;

  public encabezado: string = ""; public nombreBeca: string = ""; public detBeca: string = ""; public indBeca: string = "";
  public vecGrupo = []; public vecEncuesta = []; public vecAddEncuesta = [];
  public vecGrupos = []; public vecAsignacion = []; public vecOpciones = [];

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent, private srvSelect: SeleccionService,
    private tools: ToolsService) { }

  ngOnInit() {

    this.verGruposPreguntas();
    this.verDatosEncuesta();
    this.verDatosGrupos();

    this.encabezado = "Pisicología educativa";
    this.instanciaVariables(0, localStorage.getItem('localNumEnc'), 1, 1);
  }

  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verGruposPreguntas() {
    this.cargando.abrir();
    this.vecGrupos = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(51, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupos = resGrupo.encuesta;
      this.verAsignaciones();
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de preguntas en ese momento');
    this.cargando.cerrar();
  }
  //CARGAR LOS ATRIBUTOS DE LAS PREGUNTAS A ASIGNAR
  async verAsignaciones() {
    this.vecAsignacion = []; this.vecOpciones = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(8, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success)
      this.vecAsignacion = resGrupo.encuesta;

    const resOpcion = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(9, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resOpcion.success)
      this.vecOpciones = resOpcion.encuesta;
  }

  //MOSTRAR LA INFORMACION DE LA ENCUESTA SELECCIONADA
  async verDatosEncuesta() {
    this.vecEncuesta = [];
    const resEnc = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(12, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEnc.success) {
      this.vecEncuesta = resEnc.encuesta;
      this.nombreBeca = this.vecEncuesta[0]['strNombre']
      this.detBeca = this.vecEncuesta[0]['strDescripcion']
      this.indBeca = this.vecEncuesta[0]['strRecomendacion']
    }
    else
      this.alerti.message('No se encntró información de la encuesta Seleccionada');
  }
  //MOSTRAR LA INFORMACION DE LOS GRUPOS DE PREGUNTAS REGISTADOS ACTIVOS
  async verDatosGrupos() {
    this.vecGrupo = [];
    const resEnc = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(2, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEnc.success)
      this.vecGrupo = resEnc.encuesta;
  }


  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModGrupo(nombModal) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaVariables(0, localStorage.getItem('localNumEnc'), 1, 1);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //ABRIR EL MODAL QUE PERMITE EDITAR UN GRUPO DE PREGUNTAS
  verModEditaGrupo(datoEncuesta, nombModal) {
    if (localStorage.getItem('modUser') == 'true') {
      this.instanciaVariables(datoEncuesta.intIdGrupo, datoEncuesta.intIdEncuesta, datoEncuesta.intOrden, datoEncuesta.estEncGrupo);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //REGISTRAR UN NUEVO GRUPO
  ingresoGrupo() {
    this.gestionGrupo(this.vecAddEncuesta[0]['grupo'], this.vecAddEncuesta[0]['encuesta'], this.vecAddEncuesta[0]['estado'], localStorage.getItem('idPersona'),
      this.vecAddEncuesta[0]['orden'], 'na', 'na', 'na', 'na', 7);
  }
  //GESTIONA LAS ACTIVADES A REALIZAR SOBRE EL GRUPO INGRESAR - EDITAR
  gestionGrupo(param1, param2, param3, param4, param5, param6, param7, param8, param9, op) {
    this.srvInsert.ingresoEncuesta(param1, param2, param3, param4, param5, param6, param7, param8, param9, 'na', op).subscribe(res => {
      if (res.encuesta) {
        this.alerti.success('Datos registrados correctamente');

        this.cerrarModal();
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    });
  }
  //INSTANCIAR VARIABLES
  instanciaVariables(dato1, dato2, dato3, dato4) {
    this.vecAddEncuesta = [];
    this.vecAddEncuesta.push({ grupo: dato1, encuesta: dato2, orden: dato3, estado: dato4 });
  }
  cerrarModal() {
    this.mr.close();
  }
}
